module.exports = __webpack_public_path__ + "img/east.d987dcc5.png";